export default {
  title: 'Ordrefakturaer',
  list: {
    empty_list: {
      title: 'Ingen ordrefakturaer endnu.',
    },
    fields: {
      id: 'ID',
      total: 'I alt',
      date: 'Dato',
    },
  },
  export_modal: {
    title: 'Filter',
    start_date: {
      title: 'Startdato',
      placeholder: 'dato',
    },
    end_date: {
      title: 'Slutdato',
      placeholder: 'dato',
    },
    button: {
      title1: 'Anvend',
      title2: 'Luk',
    },
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
};
